import type { Card } from '../../interfaces/ICardItem';

export class LoadReports {
    static readonly type = '[Reports] Load reports';

    constructor(public payload: { lang: string }) {}
}

export class AddReport {
    static readonly type = '[Reports] Add report';

    constructor(public payload: { report: Card }) {}
}

export class UpdateReport {
    static readonly type = '[Reports] Update report';

    constructor(public payload: { report: Card }) {}
}

export class DeleteReport {
    static readonly type = '[Reports] Delete report';

    constructor(public payload: { id: number }) {}
}
